import { solicitar } from '../identidad/cliente-identidad.js'

export interface UnidadDidactica {
  id: string
  expedienteId: string
  grado: number
  grupo: 'A' | 'B' | 'C' | 'D'
  archivoId: string
  nombreArchivo: string
  tamano: number
  creadoEn: string
  version: number
  cantidadPlaneaciones: number
}
export interface PlaneacionClase {
  id: string
  unidadId: string
  secuencia: number
  tema: string
  competencias: Array<{
    competencia: string
    componente: string
    indicadorDesempeno: string
  }>
  referenteConceptual: string
  momentoInicial: string
  momentoCentral: string
  momentoFinal: string
  metodologia: string
  evaluacion: string
  recursos: string
  bibliografia: string
  observaciones: string
  version: number
  creadoEn: string
  actualizadoEn: string
}
export type DatosPlaneacion = Omit<
  PlaneacionClase,
  'id' | 'unidadId' | 'version' | 'creadoEn' | 'actualizadoEn' | 'tema' | 'competencias'
> & {
  tema?: string
  competencias?: PlaneacionClase['competencias']
}

export const listarUnidades = (expedienteId: string) =>
  solicitar<{ datos: UnidadDidactica[] }>(`/api/v1/expedientes/${expedienteId}/unidades`)
export const crearUnidad = (expedienteId: string, archivo: File, grado: number, grupo: string) => {
  const formulario = new FormData()
  formulario.append('archivo', archivo)
  formulario.append('grado', String(grado))
  formulario.append('grupo', grupo)
  return solicitar<{ id: string }>(`/api/v1/expedientes/${expedienteId}/unidades`, {
    method: 'POST',
    body: formulario,
  })
}
export const actualizarUnidad = (unidad: UnidadDidactica, grado: number, grupo: string) =>
  solicitar<void>(`/api/v1/unidades/${unidad.id}`, {
    method: 'PATCH',
    body: JSON.stringify({ grado, grupo, version: unidad.version }),
  })
export const listarPlaneaciones = (unidadId: string) =>
  solicitar<{ datos: PlaneacionClase[] }>(`/api/v1/unidades/${unidadId}/planeaciones`)
export const crearPlaneacion = (unidadId: string, datos: DatosPlaneacion) =>
  solicitar<{ id: string }>(`/api/v1/unidades/${unidadId}/planeaciones`, {
    method: 'POST',
    body: JSON.stringify(datos),
  })
export const actualizarPlaneacion = (planeacion: PlaneacionClase, datos: DatosPlaneacion) =>
  solicitar<void>(`/api/v1/planeaciones/${planeacion.id}`, {
    method: 'PATCH',
    body: JSON.stringify({ ...datos, version: planeacion.version }),
  })
